<div class="body" style="display: none">
<h1 mat-dialog-title>Exportar Excel </h1> <br/>

<mat-dialog-content>
    <div class = "table-responsive"  >

        <table class = "table" id="excel-tables">
        
           
                <tr>
                    <th scope = "col"> N° Postulación</th>

                    <th scope = "col">Rut Titular</th> 
                    
                    <th scope = "col">Titular</th>                   

                    <th scope = "col">Rut carga</th>
                    
                    <th scope = "col">Nombre carga</th> 

                                    
                    
                    <th scope = "col">Fecha de Ingreso  </th>

                    <th scope = "col">Producto </th>

                    <th scope = "col"> Tipo producto  </th>

                    <th scope = "col"> Categoría de prestación  </th>

                    <th scope = "col">Monto </th>

                    <th scope = "col">Estado </th>
                
                    <th scope = "col"> </th>
                </tr>    
                                
                <tr [class] = "i % 2 == 0 ? 'rowEven' : 'rowOdd'" *ngFor = "let agrupacion of agrupacionesFinales;  let i = index">
                  
                    <td> {{agrupacion.id}} </td>  

                    <td> {{agrupacion.rutTitular}} </td>  

                    <td> {{agrupacion.nombreTitular}} </td>  
               
                    <td> {{agrupacion.rutCarga}} </td>  

                    <td> {{agrupacion.nombreCarga}} </td>          
                                    
                    <td>  {{agrupacion.fechaCreacion}} </td>

                    <td>  {{agrupacion.nombreProducto}} </td>

                    <td>  {{agrupacion.nombreTipoProducto}} </td>

                    <td>  {{agrupacion.subcategoriaProducto}} </td>

                    <td>  {{agrupacion.montoReembolso}} </td>

                    <td>  {{agrupacion.estado}}</td>
                  
                </tr>
           
        
        </table> <br/>

                    
    </div>
</mat-dialog-content>

</div>
<div>
<h1 mat-dialog-title>Exportando Excel... </h1> <br/>
</div>

